export class LinkedBusiness {
    public id: number = 0;
    public businessId: number = 0;
    public topLevelBusinessId: number = 0;
    public topLevelBusinessTradeName: string ='';

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): LinkedBusiness {
        const linkedBusiness: LinkedBusiness = new LinkedBusiness();

        linkedBusiness.id = this.id;
        linkedBusiness.businessId = this.businessId;
        linkedBusiness.topLevelBusinessId = this.topLevelBusinessId;
        linkedBusiness.topLevelBusinessTradeName = this.topLevelBusinessTradeName;

        return linkedBusiness;
    }
}
